// import logo from './logo.svg';
import './App.css';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Home from './components/Home';
import Header from "./components/Header";
import Footer from './components/Footer';
import CGPAToPercent from './components/CgpaToPercent';
import About from './components/About';
import GradeToSgpa from './components/GradeToSgpa';
// import SgpaToCgpa from './components/SgpaToCgpa';
import CGPACalculator from './components/CgpaCalculator';
import Notification from './components/Notification';
import Help from './components/Help';
import HelpGradeToSgpa from './components/help/HelpGradeToSgpa';

function App() {
  return (
    <RouterProvider router={router}>
    </RouterProvider>
  );
}

const router=createBrowserRouter([
  {
    path:'/',
    element:
    <>
    <Header/>
    <Home/>
    <Footer/>
    </>
  },
  {
    path:'/about',
    element:<>
      <Header/>
   <About/>
    <Footer/>
    </>
  },
  {
    path:'/cgpa-to-percent',
    element:<>
    <Header/>
      <CGPAToPercent/>
      <Footer/>
    </>
  },
  {
    path:'/grade-to-sgpa',
    element:<>
      <Header/>
   <GradeToSgpa/>
   <Footer/>
    </>
  },
 
  {
    path:'/cgpa-calculator',
    element:<>
      <Header/>
   <CGPACalculator/>
   <Footer/>
    </>
  },
  {
    path:'/help',
    element:<>
      <Header/>
   <Help/>
   <Footer/>
    </>
  },
  {
    path:'/help/grade-to-sgpa',
    element:<>
    <Header/>
<HelpGradeToSgpa/>
    <Footer/>
    </>
  }
])

export default App;
